<button
  class="a-button select-none"
  [ngClass]="{
    'a-button--primary': buttonType === ButtonTypeEnum.PRIMARY,
    'a-button--secondary': buttonType === ButtonTypeEnum.SECONDARY,
    'a-button--tertiary': buttonType === ButtonTypeEnum.TERTIARY,
    'a-button--tertiary__ng-portal': buttonType === ButtonTypeEnum.TERTIARY_NGPORTAL,
    'integrator-button': isIntegratorButton,
    '-without-icon': !icon,
  }"
  [disabled]="isDisabled"
  [ngStyle]="{ cursor: isDisabled ? 'default' : 'pointer' }"
>
  @if (icon) {
    <i [class]="icon + ' a-button__icon'"></i>
  }
  <span class="a-button__label select-none">{{ buttonLabel }}</span>
</button>
